export const msalConfig = {
    auth: {
        clientId: "deb983f5-3a53-4f3e-82e9-f6d18391f63b",
        authority: "https://login.microsoftonline.com/4f2e4dbd-a1e0-4398-a851-5eacf3624515",
        redirectUri: "https://novack.intelnova.co/login"
    },
    cache: {
        cacheLocation: "localStorage", 
        storeAuthStateInCookie: false,
    }
}

export const loginRequest = {
    scopes: ["openid", "profile", "email"]
};